import os from '@edu-fe/os'
import login from '@/utils/login'

import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'
import mine from '../types/mine.types'

const name = 'mine'

export default {
  name,
  namespaced: true,
  state: {
    errMessage: [0, ''],
    learnInfo: {},
    courseList: [],
    couponList: [],
    swiperOptions: {},
    sendCourses: [], // 购买的赠送课程
    tabIndex: 0
  },
  getters: {
    bar () {
      return os.type === 'app'
    }
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    },

    [mine.SET_LEARN_INFO] (state, data) {
      assign(state, { learnInfo: data })
    },

    [mine.SET_COUPON] (state, data) {
      assign(state, { couponList: [].concat(data.inUsing.list, data.expired.list) })
    },

    [mine.SET_COURSE] (state, data) {
      assign(state, { courseList: data })
    },

    [mine.SET_SEND_COURSES] (state, data) {
      assign(state, { sendCourses: data })
    }
  },
  actions: {
    async setTab ({ commit, rootState, state }) {
      let tabIndex = ['course', 'coupon', 'balance'].indexOf(rootState.route.query.type)
      tabIndex = tabIndex === -1 ? 0 : tabIndex
      commit('set', { tabIndex })
    },

    async getLearnInfo ({ commit }) {
      try {
        const res = await api.mine.learn()
        commit(mine.SET_LEARN_INFO, res.data)
      } catch (E) {
        // commit(global.ERR, { message: '抱歉，获取用户信息出错，请稍后再试！' }, { root: true })
      }
    },

    async getCoupon ({ commit, state }) {
      try {
        const { code, data } = await api.mine.coupon()

        if (code === -2) {
          await login.login()
          window.location.reload()
        } else {
          commit(mine.SET_COUPON, data)
        }
      } catch (E) {
        console.log(E)
        commit(global.ERR, { message: '抱歉，获取优惠券信息出错，请稍后再试！' }, { root: true })
      }
    },

    async getCourse ({ commit }) {
      try {
        const res = await api.mine.course()
        commit(mine.SET_COURSE, res.data)
      } catch (E) {
        console.log(E)
        commit(global.ERR, { message: '抱歉，获取课程信息出错，请稍后再试！' }, { root: true })
      }
    },

    async getSendCourses ({ commit }) {
      try {
        const res = await api.mine.getSendCourses()
        commit(mine.SET_SEND_COURSES, res.data)
      } catch (err) {
        console.log(err)
        commit(global.ERR, { message: '获取课程信息出错，请稍后再试！' }, { root: true })
      }
    },

    async init ({ dispatch, rootState }) {
      if (!rootState.vipOperationList.length) {
        dispatch('getPrivilege', null, { root: true })
      }
      dispatch('setTab')
      setTimeout(async () => {
        await dispatch('getLearnInfo')
        await dispatch('getCoupon')
        // await dispatch('getCourse')
        // await dispatch('getSendCourses')
      }, 500)
    },

    setTabIndex ({ commit }, index) {
      commit('set', { tabIndex: index })
    }
  }
}
